import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import injectReducer from 'utils/injectReducer';
import { isiOS } from 'utils/common';
import { dateStringToCustomDateTime } from 'utils/dateUtils';
import PassiveModeFooter from 'patientApp/components/PassiveModeFooter';
import FloatingLabelInput from 'components/FloatingLabelInput';
import LightboxModal from 'components/LightboxModal';
import './styles.scss';
import 'patientApp/containers/ViewDataDownloadRequest/styles.scss'
import validate from 'common/validator';
import HelpBlock from 'components/HelpBlock';
import viewShareOutcomesRequestReducer from './reducers';
import {markDownloadedAt, markViewedAt, verifyPinRequest} from './actions';
import { STATUSES } from './constants';

const validationConfig = {
  fields: ['pin'],
  rules: {
    pin: [{ rule: 'isRequired', message: 'PIN is required' }],
  },
};

class ViewShareOutcomesRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      key: "",
      pin: "",
      shouldShowForm: true,
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const key = this.props.match.params.key;
    const pin = queryParams.get("pin");

    if (pin !== null) {
      this.props.verifyPin(key, pin);
    }

    this.setState({
      key,
      pin,
      shouldShowForm: pin === null,
    });
  }

  onPinChange = (e) => {
    this.setState({
      pin: e.target.value.trim(),
    });
  }

  onContinue = (event) => {
    event.preventDefault();
    validate(
      validationConfig,
      this.state,
      this.onFormValidationFailure,
      this.onFormValidationSuccess
    );
  }

  onFormValidationFailure = (errors) => {
    this.setState({ errors });
  };

  onFormValidationSuccess = () => {
    this.setState({
      errors: {},
    });
    this.props.verifyPin(this.state.key, this.state.pin);
  }

  downloadFile = (downloadLink) => {
    let win = null;
    if (isiOS) {
      win = window.open('');
    }
    if (isiOS && win) {
      win.location = downloadLink;
    } else {
      win = window.location.assign(downloadLink, '_blank');
    }
    if (!(win === undefined || win === null)) {
      win.focus();
    }
    this.props.markDownloadedAt(this.state.key, this.state.pin);
  };

  renderStatusText = (status) => {
    let textString = null;
    switch (status) {
      case STATUSES.PREPARED:
        textString = 'Your download is ready';
        break;
      case STATUSES.REQUESTED:
        textString = 'Your surveys report is being prepared for download';
        break;
      case STATUSES.INPROGESS:
        textString = 'Your surveys report is being prepared for download';
        break;
      case STATUSES.FAILED:
        textString = 'Something went wrong';
        break;
      default:
        textString = null;
    }
    return textString ? <div>{textString}</div> : null;
  }

  renderShareOutcomesRequest(data) {
    this.props.markViewedAt(this.state.key, this.state.pin);
    return (
      <div className="view-share-outcomes-request-container">
        <div className="col-xs-12">
          {
            data !== null ? (
              <React.Fragment>
                <div className="welcome-header">
                  {
                    this.renderStatusText(data.status)
                  }
                </div>
                {
                  data.status === STATUSES.PREPARED ? (
                    <React.Fragment>
                      <div className="row request-data-status">
                        {data.aggregation_type === "per_patient" ? (
                          <div className="data-container">
                            <span className="lbl-name">Patient:&nbsp;</span>
                            <span className="value">{data.patient_name}</span>
                          </div>
                          ) : data.performer_name ? (
                          <div className="data-container">
                            <span className="lbl-name">Provider:&nbsp;</span>
                            <span className="value">{data.performer_name}</span>
                          </div>
                        ) : null
                        }

                        <div className="data-container">
                          <span className="lbl-name">Procedure:&nbsp;</span>
                          <span className="value">{data.procedure_name}</span>
                        </div>
                        <div className="data-container">
                          <span className="lbl-name">Report Type:&nbsp;</span>
                          <span className="value">{data.report_type}</span>
                        </div>
                        <div className="data-container">
                          <span className="lbl-name">Shared By:&nbsp;</span>
                          <span className="value">{data.shared_by_name}</span>
                        </div>
                        <div className="data-container">
                          <button className="btn btn-primary download" onClick={() => this.downloadFile(data.download_link)}> Download &nbsp;</button>
                          <div className="expiring-text">{`(Expiring on: ${dateStringToCustomDateTime(data.download_link_expiry)})`}</div>
                        </div>
                      </div>
                    </React.Fragment>
                  ) : null
                }
              </React.Fragment>
            ) : null
          }
        </div>
        <PassiveModeFooter />
      </div>
    );
  }

  renderErrorMessage() {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p style={{ fontSize: "18px" }}>
          The resource you are looking for was not found
        </p>
      </div>
    );
  }

  render() {
    if (this.props.shareOutcomesRequest) {
      return this.renderShareOutcomesRequest(this.props.shareOutcomesRequest);
    }

    if (this.props.isLoading) {
      return (
        <LightboxModal
          show={this.props.isLoading || !this.state.shouldShowForm}
        />
      );
    }

    return (
      <div className="view-data-download-request-container">
        {this.state.shouldShowForm ? (
          <>
            <div className="welcome-header">
              Please Enter Your PIN code: &nbsp;
            </div>
            <div className="login-form-view text-center">
              <div className="">
                <br />
                We sent a PIN code to your email / mobile number:
              </div>
              <form name="form" onSubmit={this.onContinue}>
                <div
                  className={`form-group pos-rel ${
                    this.state.errors.verificationCode !== undefined
                      ? "has-error"
                      : ""
                  }`}
                >
                  <FloatingLabelInput
                    type="text"
                    className="form-control"
                    value={this.state.pin}
                    label="PIN"
                    name="pin"
                    onChange={this.onPinChange}
                  />
                  <HelpBlock value={this.state.errors.pin} />
                </div>

                <div className="clearfix"></div>

                <div className="text-center">
                  <button className="btn btn-primary">Continue</button>
                </div>
              </form>
            </div>
          </>
        ) : (
          this.renderErrorMessage()
        )}
        <PassiveModeFooter />
      </div>
    );
  }
}

ViewShareOutcomesRequest.propTypes = {
  isLoading: PropTypes.bool,
  match: PropTypes.object,
  verifyPin: PropTypes.func,
  shareOutcomesRequest: PropTypes.object,
  markViewedAt: PropTypes.func,
  markDownloadedAt: PropTypes.func,
};

const mapStateToProps = (state, props) => ({
  isLoading: state.viewShareOutcomesRequest.isLoading,
  shareOutcomesRequest: state.viewShareOutcomesRequest.shareOutcomesRequest,
});

const mapDispatchToProps = (dispatch) => ({
  verifyPin: (key, pin) => dispatch(verifyPinRequest(key, pin)),
  markViewedAt: (key, pin) => dispatch(markViewedAt(key, pin)),
  markDownloadedAt: (key, pin) => dispatch(markDownloadedAt(key, pin)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({
  key: 'viewShareOutcomesRequest',
  reducer: viewShareOutcomesRequestReducer,
});

export default compose(
  withReducer,
  withConnect,
)(ViewShareOutcomesRequest);
